import FileUploader from './GenUploader'

export default FileUploader
